/**
 * @file automatically generated from MApp.Spatial.Ogc.SpatialType
 */

export enum SpatialType {
    BBox = 0,
    Equals = 1,
    Disjoint = 2,
    Touches = 3,
    Within = 4,
    Overlaps = 5,
    Crosses = 6,
    Intersects = 7,
    Contains = 8,
    DWithin = 9,
    Beyond = 10
}
